import { DONT_CARE, Equipment, OptionsSetting } from '../../../types/backendType';
import { EquipmentInput } from './creation/treatmentPlanTypes';
import { isEmpty } from '../../../state-manager/utils/compare';

export function isCameraSide(sideSetting: OptionsSetting) {
  return Boolean(sideSetting.options.includes(DONT_CARE));
}

// Transform all legacy selected values (strings) into objects
export function transformLegacyEquipment(
  legacySelectedEquipment: string[] | undefined,
  optionalEquipment: Equipment[] | undefined,
) {
  if (legacySelectedEquipment) {
    const normalizedLegacySelectedEquipment = legacySelectedEquipment
      .map((legacySelectedDevice) => {
        if (legacySelectedDevice.includes('|')) {
          return legacySelectedDevice.split('|');
        }
        return legacySelectedDevice;
      })
      .flat();

    const transformedLegacyEquipment: EquipmentInput[] = [];
    normalizedLegacySelectedEquipment.forEach((legacySelectedDevice) => {
      const deviceObject = optionalEquipment?.find(
        (device) => device.Name === legacySelectedDevice,
      );
      if (deviceObject) {
        transformedLegacyEquipment.push({
          ...deviceObject,
          IsRequired: false,
          Value: deviceObject.Default,
        });
      }
    });
    return transformedLegacyEquipment;
  }
}

export function isLoadInput(device: EquipmentInput) {
  return Boolean(device.Units && !device.Options);
}

export const OTHER_OPTION = 'Other';
export const OTHER_OPTION_TEXT_MAX_LENGTH = 32;

export function offersOtherOption(device: Equipment) {
  return Boolean(device.Options?.includes(OTHER_OPTION));
}

// Choosing "Other" lets the clinician type the real value (e.g. a band color
// missing from the list). That text is stored as the Value itself, which is
// why a Value outside Options also means "Other".
export function isOtherOptionValue(device: EquipmentInput) {
  if (!offersOtherOption(device) || isEmpty(device.Value)) {
    return false;
  }
  const value = String(device.Value);
  return value === OTHER_OPTION || !device.Options?.includes(value);
}

export function normalizeOtherOptionValue(device: EquipmentInput): EquipmentInput {
  if (!offersOtherOption(device) || typeof device.Value !== 'string') {
    return device;
  }
  if (isEmpty(device.Value)) {
    return device;
  }
  const trimmed = device.Value.trim();
  return { ...device, Value: trimmed === '' ? OTHER_OPTION : trimmed };
}
